const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M13.97 18.47a.75.75 0 1 0 1.06 1.06l3.39-3.39a.75.75 0 0 0 0-1.28l-3.39-3.39a.75.75 0 1 0-1.06 1.06l2.22 2.22H10a3.25 3.25 0 0 1-3.25-3.25V4.998a.75.75 0 0 0-1.5.001V11.5A4.75 4.75 0 0 0 10 16.25h6.19z"/></svg>';
export {
  a as w
};
